import React, {useEffect} from "react";
import {connect} from "react-redux";
import * as PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { history } from "../../redux/store/configureStore";
import TeachersList from "./TeachersList";
import * as teacherActions from "../../redux/actions/teacherActions";
import {
  buildManageRouteWithSchoolYear,
  getNormalizedSchoolYearStartYearFromSearch,
} from "./manageSchoolYearRouting";

function Teachers({ teachers, loadTeachers, ...props }) {
  const location = useLocation();
  const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);

  useEffect(() => {
    if (teachers.length === 0) {
      loadTeachers()
        .catch((error) => {
          alert(`Loading teachers failed ${error}`);
        });
    }
  }, []);


  const handleEdit = (teacher) => {
    history.push(buildManageRouteWithSchoolYear(`/manage/teacher/${teacher.id}`, location.search, activeSchoolYearStartYear));
  };

  const handleAdd = () => {
    history.push(buildManageRouteWithSchoolYear("/manage/teacher/new", location.search, activeSchoolYearStartYear));
  };

  return (
    <div className="mb-5">
      <TeachersList
        teachers={teachers}
        onAdd={handleAdd}
        onEdit={handleEdit}
      />
    </div>
  );
}

Teachers.propTypes = {
  teachers: PropTypes.array.isRequired,
  loadTeachers: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return ({
    teachers: state.teachers,
  });
};

const mapDispatchToProps = dispatch => ({
  loadTeachers: () => dispatch(teacherActions.loadTeachers()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Teachers);
